
    <a class="nav-link nav-dropdown-toggle" appNavDropdownToggle>
      <i *ngIf="isIcon()" class="{{ link.icon }}"></i>
      {{ link.name }}
      <span *ngIf="isBadge()" [ngClass]="'badge badge-' + link.badge.variant">{{ link.badge.text }}</span>
    </a>
    <ul class="nav-dropdown-items">
      <ng-template ngFor let-child [ngForOf]="link.children">
        <app-sidebar-nav-item [item]='child'></app-sidebar-nav-item>
      </ng-template>
    </ul>
  


// WEBPACK FOOTER //
// /home/ec2-user/jenkins/workspace/new-roamingse/prod/roamingse-frontend/src/app/components/app-sidebar-nav/app-sidebar-nav.component.ts.AppSidebarNavDropdownComponent.html